import * as React from "react";
const SvgCrop32 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 4H3v16h18V4zm-2 14H5V6h14v12z",
  fill: "currentColor"
}));
export default SvgCrop32;